import React, { useEffect } from 'react';
import './Chatbots.css'
import collections from './collection.data.js';

const Chatbots = () => {

  useEffect(() => {
    document.querySelector('body').style.backgroundColor = '#badad7'
  }, []);

  return (
    <div className="ChatbotPage" >
      <h1 className="Title" >Student Chatbots</h1>
      <div className="ChatbotInfo">
        <h3>
          Students in CMPT 120 at SFU have created Blackfoot chatbots for the
          end of year project
        </h3>
        <p>
          To understand if it is possible to learn a language
          as the developer of a chatbot, we surveyed the students
          before and after completing the project
        </p>
        <div className="Stats">
          <div className="Percentage">
            <p className="Highlight">
              80%
            </p>
            <p>
               Had never heard of Blackfoot before their project
            </p>
          </div>
          <div className="Percentage">
            <p className="Highlight">
              100%
            </p>
            <p>
               Thought building a chatbot was a fun way
              to be introduced to a new language
            </p>
          </div>
          <div className="Percentage">
            <p className="Highlight">
              100%
            </p>
            <p>
              Would like to see cultural elements added to the chatbot
            </p>
          </div>
          <div className="Percentage">
            <p className="Highlight">
              82%
            </p>
            <p>
              Believe they could learn grammar and syntax if these were added
              to the chatbot
            </p>
          </div>
        </div>
        <p>
          The students were quizzed on their Blackfoot knowledge before and
          after the project to see how much they learned
        </p>
        <div className="Stats">
          <div className="Percentage">
            <p>
               The average pre-score was
            </p>
            <p className="Highlight">
              38%
            </p>
          </div>
          <div className="Percentage">
            <p>
               The average post-score was
            </p>
            <p className="Highlight">
              72%
            </p>
          </div>
        </div>
        <p>
          We learned that recalling single Blackfoot words was easiest for
          students and translating full sentences and audio clips was the
          most difficult
        </p>
        <div className="Stats">
          <div className="Percentage">
            <p>
               The average score for single word Blackfoot to English
               translations was
            </p>
            <p className="Highlight">
              89%
            </p>
          </div>
          <div className="Percentage">
            <p>
               The average score for full sentences and audio translations was
            </p>
            <p className="Highlight">
              61%
            </p>
          </div>
        </div>
        <p className='Prompt'>
          Click on the images below to try out the chatbots!
        </p>
      </div>
      <div className="collection-item">
        {collections
          .map((obj, idx) => {
            return (
              <span key={`projectt_ilinks${idx}`}>
                <a
                  href={
                    `${obj.projectUrl}`
                  } target="_blank" rel="noreferrer"
                >
                  <span>
                    <img className="image" src={obj.imageUrl} />
                  </span>
                </a>
                <span className="name">{obj.name}</span>
              </span>
            );
          })}
      </div>
    </div>
  );
}

export default Chatbots;
